import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SecondaryCriteriaType } from "@planzone/dto";
import { SelectList } from "@common/selectList";
import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function TypeInput({ value, input }: Props) {
  const { t } = useTranslation();
  const types: SecondaryCriteriaType[] = [
    "text",
    "richText",
    "number",
    "date",
    "list",
    "document",
    "link",
    "resource",
  ];

  return (
    <div className={styles.nameInput}>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("secondaryCriteriaTemplate.form.type.label")}
        </p>
        <SelectList listClassName={styles.listRoot}>
          {({ isOpen, select, show, hide }) => ({
            input: (
              <div
                className={classNames(styles.input, { [styles.open]: isOpen })}
              >
                <div className={styles.row}>
                  <SecondaryCriteriaIcon type={value} className={styles.icon} />
                  <p className={styles.name}>
                    {t(`secondaryCriteriaTemplate.form.type.types.${value}`)}
                  </p>
                </div>
                <ToggleArrowIcon className={styles.toggleArrow} />
              </div>
            ),
            list: (
              <div className={styles.list}>
                {types.map((type) => (
                  <div
                    key={type}
                    className={classNames(styles.item, {
                      [styles.selected]: type === value,
                    })}
                    onClick={() => value !== type && select(input(type))}
                  >
                    <SecondaryCriteriaIcon
                      type={type}
                      className={styles.icon}
                    />
                    <p className={styles.name}>
                      {t(`secondaryCriteriaTemplate.form.type.types.${type}`)}
                    </p>
                  </div>
                ))}
              </div>
            ),
          })}
        </SelectList>
      </div>
    </div>
  );
}

export { TypeInput };
